import { render, staticRenderFns } from "./workbenchSupplier.vue?vue&type=template&id=08db2210&scoped=true"
import script from "./workbenchSupplier.vue?vue&type=script&lang=js"
export * from "./workbenchSupplier.vue?vue&type=script&lang=js"
import style0 from "./workbenchSupplier.vue?vue&type=style&index=0&id=08db2210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db2210",
  null
  
)

export default component.exports